// extracted by mini-css-extract-plugin
export var headerSection = "VideoBkgHero-module--headerSection--48898";
export var heading = "VideoBkgHero-module--heading--803bd";
export var headingButton = "VideoBkgHero-module--headingButton--dd739";
export var headingContent = "VideoBkgHero-module--headingContent--44309";
export var headingContentWrapper = "VideoBkgHero-module--headingContentWrapper--5ffba";
export var playerWrapper = "VideoBkgHero-module--playerWrapper--b9d8d";
export var reactPlayer = "VideoBkgHero-module--reactPlayer--3db06";